import * as commonConsts from '../../../../pages/common/CommonConsts';
import {
  isNumeric,
  isSelected,
  isCompleted,
  isValidEmail,
  isAustralianPhoneNumberWithCountryCodeOrNull,
  isAustralianPhoneNumberWithOutCountryCodeOrNull
} from '../../../../utils/Validation';

const getAddValidatorsOrganisationAuditor = (props) => [
  {
    fieldName: 'auditorType',
    fieldValue: props.auditorType,
    isValid: (v) => isSelected(v)
  },
  //Organisation Validation Checks
  {
    fieldName: 'isUniqueOrganisation',
    fieldValue: {
      organisationData: props.organisationData,
      newAccountants: props.newAccountants
    },
    isValid: (v) => {
      if (v.organisationData?.abn) {
        const duplicateOrganisation = v.newAccountants.find((a) => a.id === v?.siebelRowId);
        if (duplicateOrganisation) {
          return false;
        }
      }

      return true;
    }
  },
  {
    fieldName: 'organisationSearch',
    fieldValue: props.organisationSearchCriteria,
    isValid: (v) => {
      return isCompleted(v?.searchType);
    }
  },
  // {
  //   fieldName: 'registrationNumber',
  //   fieldValue: props.registrationNumber,
  //   isValid: (v) => isCompleted(v)
  // },
  {
    fieldName: 'organisationName',
    fieldValue: props,
    isValid: (v) => {
      if (!!v?.organisationData?.siebelRowId) {
        return true;
      }

      if (v?.organisationSearchCriteria?.manualYinc === true) {
        var result = isCompleted(v?.organisationSearchCriteria?.organisationName);
        return result;
      }

      return true;
    }
  },

  //Lead Accountant Validation Checks
  {
    fieldName: 'firstName',
    fieldValue: props.organisationContactFirstName,
    isValid: (v) => isCompleted(v)
  },
  {
    fieldName: 'lastName',
    fieldValue: props.organisationContactLastName,
    isValid: (v) => isCompleted(v)
  },
  {
    fieldName: 'qualification',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      return isCompleted(v?.qualifications);
    }
  },
  {
    fieldName: 'qualificationCertificateNumber',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      if (v?.qualifications === commonConsts.qualificationNoFormal) {
        return true;
      } else if (v?.qualifications === commonConsts.qualificationRegisteredCompanyAuditor) {
        return isCompleted(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationCertificateNumberValid',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      if (v?.certificateNumber) {
        return isNumeric(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationNoFormalDescription',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      if (v?.qualifications !== commonConsts.qualificationNoFormal) {
        return true;
      } else {
        return v?.qualifications === commonConsts.qualificationNoFormal && isCompleted(v?.details);
      }
    }
  },
  {
    fieldName: 'emailAddress',
    fieldValue: props.organisationContactEmailAddress,
    isValid: (v) => isValidEmail(v)
  },
  {
    fieldName: 'primaryContactPrefix',
    fieldValue: props.organisationContactPrimaryContactNumber,
    isValid: (v) => {
      //return v === commonConsts.australianCountryCode;
      if (v?.prefix === '') {
        return false;
      }

      if (Array.isArray(v?.prefix)) {
        return false;
      }

      const validPrefix = commonConsts.australianPhonePrefixes.find((x) => x === v?.prefix);
      if (validPrefix) {
        return true;
      } else {
        return false;
      }
    }
  },
  {
    fieldName: 'primaryContactNumber',
    fieldValue: props.organisationContactPrimaryContactNumber,
    isValid: (v) => {
      //return isCompleted(v) && isAustralianPhoneNumberOrNull(v);
      if (v === undefined) {
        return false;
      }

      if (!v?.number) {
        return false;
      }

      if (v?.prefix === commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithCountryCodeOrNull(v?.number);
      }

      if (v?.prefix !== commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithOutCountryCodeOrNull(v?.number);
      }
    }
  },
  {
    fieldName: 'businessAddress',
    fieldValue: {
      addressBusiness: props.organisationContactBusinessAddress,
      addressPostal: props.organisationContactPostalAddress,
      isOrganisationContactBusinessAddressValid: props.isOrganisationContactBusinessAddressValid
    },
    isValid: (v) => {
      return (
        v.isOrganisationContactBusinessAddressValid ||
        v.addressBusiness?.lookupValue ||
        v.addressBusiness?.enterManually
      );
    }
  },
  {
    fieldName: 'postalAddress',
    fieldValue: {
      sameAsBusinessAddress: props.organisationContactSameAsBusinessFlag,
      addressBusiness: props.organisationContactBusinessAddress,
      addressPostal: props.organisationContactPostalAddress,
      isOrganisationContactPostalAddressValid: props.isOrganisationContactPostalAddressValid
    },
    isValid: (v) => {
      let result;

      if (v.sameAsBusinessAddress) {
        result =
          v.isOrganisationContactPostalAddressValid ||
          v.addressBusiness?.lookupValue ||
          v.addressBusiness?.enterManually;
      }

      return (
        v.isOrganisationContactPostalAddressValid || v.addressPostal?.lookupValue || v.addressPostal?.enterManually
      );
    }
  }
];

const getEditValidatorsOrganisationAuditor = (props) => [
  {
    fieldName: 'auditorType',
    fieldValue: props.auditorType,
    isValid: (v) => isSelected(v)
  },

  //Lead Accountant Validation Checks
  {
    fieldName: 'firstName',
    fieldValue: {
      organisationNewContactFirstName: props.organisationNewContactFirstName,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      return isCompleted(v.organisationNewContactFirstName);
    }
  },
  {
    fieldName: 'lastName',
    fieldValue: {
      organisationNewContactLastName: props.organisationNewContactLastName,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      return isCompleted(v.organisationNewContactLastName);
    }
  },
  {
    fieldName: 'qualification',
    fieldValue: {
      organisationContactQualification: props.organisationContactQualification,
      organisationNewContactQualification: props.organisationNewContactQualification,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      if (v?.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return isCompleted(v?.organisationContactQualification?.qualifications);
      }

      return isCompleted(v?.organisationNewContactQualification?.qualifications);
    }
  },
  {
    fieldName: 'qualificationCertificateNumber',
    fieldValue: {
      organisationContactQualification: props.organisationContactQualification,
      organisationNewContactQualification: props.organisationNewContactQualification,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      let field = v?.organisationNewContactQualification?.certificateNumber;
      let qualificationsToCheck = v?.organisationNewContactQualification?.qualifications;

      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        field = v?.organisationNewContactQualification?.certificateNumber;
        qualificationsToCheck = v?.organisationContactQualification?.qualifications;
      }

      if (qualificationsToCheck === commonConsts.qualificationNoFormal) {
        return true;
      } else if (qualificationsToCheck === commonConsts.qualificationRegisteredCompanyAuditor) {
        return isCompleted(field);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationCertificateNumberValid',
    fieldValue: {
      organisationContactQualification: props.organisationContactQualification,
      organisationNewContactQualification: props.organisationNewContactQualification,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      let field = v?.organisationNewContactQualification?.certificateNumber;

      if (v?.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        field = v?.organisationContactQualification?.certificateNumber;
      }

      if (field) {
        return isNumeric(field);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationNoFormalDescription',
    fieldValue: {
      organisationContactQualification: props.organisationContactQualification,
      organisationNewContactQualification: props.organisationNewContactQualification,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      let field = v?.organisationNewContactQualification?.details;
      let qualificationsToCheck = v?.organisationNewContactQualification?.qualifications;

      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        field = v?.organisationContactQualification?.details;
        qualificationsToCheck = v?.organisationContactQualification?.qualifications;
      }

      if (qualificationsToCheck !== commonConsts.qualificationNoFormal) {
        return true;
      } else {
        return qualificationsToCheck === commonConsts.qualificationNoFormal && isCompleted(field);
      }
    }
  },
  {
    fieldName: 'emailAddress',
    fieldValue: {
      organisationNewContactEmailAddress: props.organisationNewContactEmailAddress,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      return isValidEmail(v.organisationNewContactEmailAddress);
    }
  },
  {
    fieldName: 'primaryContactPrefix',
    fieldValue: {
      organisationNewContactPrimaryContactNumber: props.organisationNewContactPrimaryContactNumber,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      if (v?.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      //return v === commonConsts.australianCountryCode;
      if (v?.organisationNewContactPrimaryContactNumber?.prefix === '') {
        return false;
      }

      if (Array.isArray(v?.organisationNewContactPrimaryContactNumber?.prefix)) {
        return false;
      }

      const validPrefix = commonConsts.australianPhonePrefixes.find(
        (x) => x === v?.organisationNewContactPrimaryContactNumber?.prefix
      );
      if (validPrefix) {
        return true;
      } else {
        return false;
      }
    }
  },
  {
    fieldName: 'primaryContactNumber',
    fieldValue: {
      organisationNewContactPrimaryContactNumber: props.organisationNewContactPrimaryContactNumber,
      isLeadAccountantDetails: props.isLeadAccountantDetails
    },
    isValid: (v) => {
      if (v?.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      //return isCompleted(v) && isAustralianPhoneNumberOrNull(v);
      if (v?.organisationNewContactPrimaryContactNumber?.number === null) {
        return false;
      }

      if (v?.organisationNewContactPrimaryContactNumber?.prefix === commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithCountryCodeOrNull(v?.organisationNewContactPrimaryContactNumber?.number);
      }

      if (v?.organisationNewContactPrimaryContactNumber?.prefix !== commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithOutCountryCodeOrNull(v?.organisationNewContactPrimaryContactNumber?.number);
      }
    }
  },
  {
    fieldName: 'businessAddress',
    fieldValue: {
      isLeadAccountantDetails: props.isLeadAccountantDetails,
      isOrganisationNewContactBusinessAddressValid: props.isOrganisationNewContactBusinessAddressValid,
      addressBusiness: props.organisationNewContactBusinessAddress
    },
    isValid: (v) => {
      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      return (
        v.isOrganisationNewContactBusinessAddressValid ||
        v.addressBusiness?.lookupValue ||
        v.addressBusiness?.enterManually
      );
    }
  },
  {
    fieldName: 'postalAddress',
    fieldValue: {
      isLeadAccountantDetails: props.isLeadAccountantDetails,
      sameAsNewContactBusinessAddress: props.organisationNewContactSameAsBusinessFlag,
      newContactAddressBusiness: props.organisationNewContactBusinessAddress,
      newContactAddressPostal: props.organisationNewContactPostalAddress,
      isNewContactPostalAddressValid: props.isOrganisationNewContactPostalAddressValid
    },
    isValid: (v) => {
      let result;

      if (v.isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
        return true;
      }

      if (v.sameAsNewContactBusinessAddress) {
        result =
          v.isNewContactPostalAddressValid ||
          v.newContactAddressBusiness?.lookupValue ||
          v.newContactAddressBusiness?.enterManually;
      }

      return (
        v.isNewContactPostalAddressValid ||
        v.newContactAddressPostal?.lookupValue ||
        v.newContactAddressPostal?.enterManually
      );
    }
  },
  {
    fieldName: 'qualificationExisting',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      return isCompleted(v?.qualifications);
    }
  },
  {
    fieldName: 'qualificationCertificateNumberExisting',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      if (v?.qualifications === commonConsts.qualificationNoFormal) {
        return true;
      } else if (v?.qualifications === commonConsts.qualificationRegisteredCompanyAuditor) {
        return isCompleted(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationCertificateNumberValidExisting',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      if (v?.certificateNumber) {
        return isNumeric(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationNoFormalDescriptionExisting',
    fieldValue: props.organisationContactQualification,
    isValid: (v) => {
      if (v?.qualifications !== commonConsts.qualificationNoFormal) {
        return true;
      } else {
        return v?.qualifications === commonConsts.qualificationNoFormal && isCompleted(v?.details);
      }
    }
  }
];

const errorsOrganisationDefaultValue = {
  auditorType: false,
  isUniqueOrganisation: false,
  organisationSearch: false,
  registrationNumber: false,
  organisationName: false,
  firstName: false,
  lastName: false,
  qualification: false,
  qualificationCertificateNumber: false,
  qualificationCertificateNumberValid: false,
  qualificationNoFormalDescription: false,
  emailAddress: false,
  primaryContactPrefix: false,
  primaryContactNumber: false,
  businessAddress: false,
  postalAddress: false,
  qualificationExisting: false,
  qualificationCertificateNumberExisting: false,
  qualificationCertificateNumberValidExisting: false,
  qualificationNoFormalDescriptionExisting: false
};

export { getAddValidatorsOrganisationAuditor, getEditValidatorsOrganisationAuditor, errorsOrganisationDefaultValue };
